import { connect } from 'react-redux';
import { appAccessControlAddUserAction } from 'Actions/appAccessControlAction';
import AddUser from 'Components/AppAccessControl/AddUser';

function mapStatetoProps(state){
    return {
        appAccessControlAddUser: state.appAccessControlAddUser
    }
}

const mapDispatchtoProps = {
    appAccessControlAddUserAction
}

export default connect(mapStatetoProps,mapDispatchtoProps)(AddUser)